'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = event;
exports.isLoaded = isLoaded;
exports.show = show;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOAD = 'eventDetail/LOAD';
var LOAD_SUCCESS = 'eventDetail/LOAD_SUCCESS';
var LOAD_FAIL = 'eventDetail/LOAD_FAIL';

var initialState = {
  loaded: false,
  loading: false
};

function event() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case LOAD:
      return (0, _extends3.default)({}, state, {
        loaded: false,
        loading: true
      });
    case LOAD_SUCCESS:
      return (0, _extends3.default)({}, state, {
        loaded: true,
        loading: false,
        data: action.result.data ? action.result.data : action.result
      });
    case LOAD_FAIL:
      return (0, _extends3.default)({}, state, {
        loaded: false,
        loading: false,
        error: action.error
      });
    default:
      return state;
  }
}

function isLoaded(globalState) {
  return globalState.event && globalState.event.loaded;
}

function show(id) {
  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    promise: function promise(client) {
      return client.get('events/' + id);
    }
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/eventDetail.js
// module id = 640
// module chunks = 0